function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { T } from 'shared/helper/translate';
var RubriqLoadingSpinner = function RubriqLoadingSpinner(_ref) {
  var _ref$text = _ref.text,
    text = _ref$text === void 0 ? 'loading' : _ref$text,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline;
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column justify-content-center align-items-center gap-2".concat(inline ? '' : ' rubriq-loading-spinner-container'),
    style: _objectSpread({
      fontSize: '20px'
    }, inline ? {
      padding: '3rem 0'
    } : {})
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-duotone fa-solid fa-spinner-third",
    spin: true,
    style: {
      color: '#027e6f'
    }
  }), /*#__PURE__*/React.createElement(T, {
    source: text
  }));
};
export default RubriqLoadingSpinner;